import { createApp } from 'vue'
import App from './App.vue'
import * as VueRouter from 'vue-router'
import store from "./store"
import moment from 'moment'
import { Capacitor } from '@capacitor/core'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.bundle'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue.js'

// Import global de vue-select
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import '@/assets/styles/ui-badges.css'
import '@/assets/styles/viewport-fixes.css'
import '@/assets/styles/native-app.css'

import '@/assets/styles/alarm-display.css'

import ClientPage from './views/ClientPage/ClientPage.vue'
import MainMap from './views/MapGL/MainMap.vue'
import LoginPage from './views/LoginPage.vue'
import MapPage from './views/Map/MapPage.vue'
import DriveMapPage from './views/Map/DriveMapPage.vue'
import DailyHistoryMap from './views/Map/DailyHistoryMap.vue'
import CorridoringMap from './views/Map/CorridoringMap.vue'
import GeofencingMap from './views/Map/GeofencingMap.vue'
import MissionMap from './views/Map/MissionMap.vue'
import MissionHistoryMap from './views/Map/MissionHistoryMap.vue'
import OffersPage from './views/OffersPage.vue'
import BaliseInfo from './views/BaliseInfo/BaliseInfo.vue'
import BaliseConfig from './views/BaliseConfig.vue'
import BalisesListAll from './views/Balises/BalisesListAll.vue'
import BadgeInfo from './views/BadgeInfo/BadgeInfo.vue'
import BadgeAlarmsList from './views/BadgeAlarmsList/BadgeAlarmsList.vue'
import BadgesList from './views/BadgesList/BadgesList.vue'
import BadgeProfilesList from './views/BadgeProfilesList/BadgeProfilesList.vue'
import GroupsPage from './views/GroupsPage/GroupsPage.vue'
import NotificationContacts from './views/NotificationContacts/NotificationContacts.vue'
import UsersPage from './views/Users/UsersPage.vue'
import OperatorsPage from './views/Users/OperatorsPage.vue'
import AdminGlobalPage from './views/AdminGlobalPage.vue'
import GeocodingPage from './views/GeocodingPage.vue'
import FAQPage from './views/FAQPage'
import ContactPage from './views/ContactPage'
import ListenersStatus from './views/ListenersStatus'
import PositionsPage from './views/PositionsPage'
import AlarmsList from './views/AlarmsList/AlarmsList'
import AlarmTypesPage from './views/alarmTypes/Index.vue'
import CorridoringList from './views/CorridoringList/CorridoringList.vue'
import MissionsList from './views/Missions/MissionsList/MissionsList.vue'
import MissionsHistory from './views/Missions/MissionsHistory/MissionsHistory.vue'
import MissionInfo from './views/Missions/MissionInfo/MissionInfo.vue'
import MissionWizardLoader from './views/Missions/Wizard/MissionWizardLoader.vue'
import WizardName from './views/Missions/Wizard/WizardNameCorridoring.vue'
import WizardTransporteur from './views/Missions/Wizard/WizardTransporteur.vue'
import WizardConvoy from './views/Missions/Wizard/WizardConvoy.vue'
import WizardDrivers from './views/Missions/Wizard/WizardDrivers.vue'
import WizardPlates from './views/Missions/Wizard/WizardPlates.vue'
import MissionsMembers from './views/MissionsMembers/MissionsMembers.vue'
import MissionPrecheckCrud from './views/MissionPrecheckCrud/MissionPrecheckCrud.vue'
import MissionAuditLogs from './views/AuditLogs/MissionAuditLogs'
import DrivesList from './views/DrivesList/DrivesList.vue'
import DriveInfo from './views/DriveInfo/DriveInfo'
import DriversPage from './views/Drivers/Index.vue'
import DriverDetails from './views/Drivers/DriverDetails.vue'
import BadgesManagement from './views/Badges/Index.vue';
import ContactList from './views/ContactList/ContactList.vue'
import PatchNotes from './views/PatchNotes'
import BaliseCommand from './views/BaliseCommand.vue'
import BillingPage from './views/Billing/BillingPage'
import RevenueProgress from './views/Billing/RevenueProgress.vue'
import TestPage from './views/TestPage'
import MissionTutorial from './views/Tutorial/MissionTutorial.vue'
import AddBalise from './views/Balises/Admin/AddBalise.vue'
import EditBalise from './views/Balises/Admin/EditBalise.vue'
import BaliseAlarmTypeConfigs from './views/Balises/Admin/BaliseAlarmTypeConfigs.vue'
import Dashboard from './views/Dashboard/MainDashboard.vue'
import PublicPositionShareMap from './views/Map/PublicPositionShareMap.vue'
import PositionShareLinksPage from './views/PositionShares/PositionShareLinksPage.vue'
import DigitalIO from './views/Balises/Admin/DigitalIO.vue'


/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import {
    faQuoteLeft,
    faStar,
    faLocationDot,
    faLocationPin,
    faCircle,
    faCircleCheck,
    faUsers,
    faUser,
    faBars,
    faBan,
    faCirclePlus,
    faPlus,
    faSquareMinus,
    faBatteryQuarter,
    faBatteryFull,
    faBatteryHalf,
    faCar,
    faBell,
    faUserGear,
    faRightFromBracket,
    faArrowUpRightFromSquare,
    faPenSquare,
    faPen,
    faLocationArrow,
    faPlug,
    faSignal,
    faChevronUp,
    faChevronDown,
    faTriangleExclamation,
    faGlobe,
    faTemperatureHalf,
    faTemperatureFull,
    faTemperatureEmpty,
    faGaugeHigh,
    faFlagCheckered,
    faCheck,
    faCirclePlay,
    faSpinner,
    faRotateRight,
    faThumbtack,
    faThumbtackSlash,
    faXmark,
    faPlay,
    faStop,
    faCircleInfo,
    faFloppyDisk,
    faLock,
    faUnlock,
    faMagnifyingGlass,
    faShieldHalved,
    faCarSide,
    faEnvelope,
    faCommentSms,
    faTrash,
    faPowerOff,
    faKey,
    faDownload,
    faCarOn,
    faFilePdf,
    faFileExcel,
    faScrewdriver,
    faReply,
    faArrowTrendDown,
    faArrowTrendUp,
    faList,
    faGrip,
    faRoute,
    faEye,
    faEyeSlash
} from '@fortawesome/free-solid-svg-icons'
import {
    faInstagramSquare,
    faLinkedin,
    faFacebookSquare,
    faTwitterSquare
} from '@fortawesome/free-brands-svg-icons'

/* add icons to the library */
library.add(
    faQuoteLeft,
    faStar,
    faInstagramSquare,
    faLinkedin,
    faFacebookSquare,
    faTwitterSquare,
    faUsers,
    faUser,
    faBars,
    faBan,
    faCirclePlus,
    faCircleCheck,
    faPlus,
    faBatteryQuarter,
    faBatteryFull,
    faBatteryHalf,
    faArrowUpRightFromSquare,
    faPenSquare,
    faPen,
    faLocationDot,
    faLocationPin,
    faCircle,
    faSquareMinus,
    faLocationArrow,
    faPlug,
    faSignal,
    faChevronDown,
    faChevronUp,
    faTriangleExclamation,
    faGlobe,
    faTemperatureHalf,
    faTemperatureFull,
    faTemperatureEmpty,
    faCar,
    faUserGear,
    faRightFromBracket,
    faBell,
    faGaugeHigh,
    faFlagCheckered,
    faCheck,
    faCirclePlay,
    faSpinner,
    faRotateRight,
    faThumbtack,
    faThumbtackSlash,
    faXmark,
    faPlay,
    faStop,
    faCircleInfo,
    faFloppyDisk,
    faLock,
    faUnlock,
    faMagnifyingGlass,
    faShieldHalved,
    faCarSide,
    faEnvelope,
    faCommentSms,
    faTrash,
    faPowerOff,
    faKey,
    faDownload,
    faCarOn,
    faFilePdf,
    faFileExcel,
    faScrewdriver,
    faReply,
    faArrowTrendDown,
    faArrowTrendUp,
    faList,
    faGrip,
    faRoute,
    faEye,
    faEyeSlash,
)

const router = VueRouter.createRouter({
    scrollBehavior(to, from, savedPosition) {
        // Restaure la position si navigation "back/forward"
        if (savedPosition) return savedPosition;
        // Ne pas modifier le scroll quand on change d'étape du tutoriel
        if (to.name === 'MissionTutorial' && from?.name === 'MissionTutorial') {
            return false; // conserve la position actuelle
        }
        // Par défaut: remonter en haut
        return { top: 0 }
    },
    history: VueRouter.createWebHistory(),
    routes: [
        {
            path: '/',
            name: 'LoginPage',
            component: LoginPage
        },
        {
            path: '/positionshare/:token',
            name: 'PublicPositionShare',
            component: PublicPositionShareMap,
            props: true,
            meta: {
                isPublic: true
            }
        },
        {
            path: '/balise/:id/position-shares',
            name: 'PositionShareLinks',
            component: PositionShareLinksPage,
            props: true
        },
        {
            path: '/clientpage',
            name: 'ClientPage',
            component: ClientPage
        },
        {
            path: '/home',
            name: 'MapPage',
            component: MapPage
        },
        {
            path: '/newmap',
            name: 'MainMap',
            component: MainMap
        },
        {
            path: '/home/:bid',
            name: 'MapFollowBalise',
            component: MapPage
        },
        {
            path: '/offers',
            name: 'OffersPage',
            component: OffersPage
        },
        {
            path: '/balise/:id',
            name: 'BaliseInfo',
            component: BaliseInfo
        },
        {
            path: '/baliseconfig',
            name: 'BaliseConfig',
            component: BaliseConfig
        },
        {
            path: '/baliseslist',
            name: 'BalisesList',
            component: BalisesListAll
        },
        {
            path: '/baliseslistall',
            name: 'BalisesListAll',
            component: BalisesListAll
        },
        {
            path: '/balise/admin/addbalise',
            name: 'AddBalise',
            component: AddBalise
        },
        {
            path: '/balise/admin/editbalise/:id?',
            name: 'EditBalise',
            component: EditBalise
        },
        {
            path: '/balise/admin/alarmtypeconfigs/:id',
            name: 'BaliseAlarmTypeConfigs',
            component: BaliseAlarmTypeConfigs
        },
        {
            path: '/balise/admin/digitalio/:baliseId',
            name: 'DigitalIO',
            component: DigitalIO
        },
        {
            path: '/drivers',
            name: 'DriversPage',
            component: DriversPage,
            meta: { requiresClient: true }
        },
        {
            path: '/drivers/:driverId',
            name: 'driver-details',
            component: DriverDetails,
            meta: { requiresClient: true }
        },
        {
            path: '/badges',
            name: 'BadgesManagement',
            component: BadgesManagement,
            meta: { requiresClient: true }
        },
        {
            path: '/badge/:id',
            name: 'BadgeInfo',
            component: BadgeInfo
        },
        {
            path: '/badgealarmslist/:id',
            name: 'BadgeAlarmsList',
            component: BadgeAlarmsList
        },
        {
            path: '/badgeslist',
            name: 'BadgesList',
            component: BadgesList,
            meta: { requiresClient: true }
        },
        {
            path: '/badgeprofileslist',
            name: 'BadgeProfilesList',
            component: BadgeProfilesList,
            meta: { requiresClient: true }
        },
        {
            path: '/groups',
            name: 'GroupsPage',
            component: GroupsPage,
            meta: { requiresClient: true }
        },
        {
            path: '/contacts',
            name: 'NotificationContacts',
            component: NotificationContacts,
            meta: { requiresClient: true }
        },
        {
            path: '/users',
            name: 'UsersPage',
            component: UsersPage,
            meta: { requiresClient: true }
        },
        {
            path: '/operators',
            name: 'OperatorsPage',
            component: OperatorsPage,
            beforeEnter: () => {
                const role = store.state?.auth?.user?.role;

                if (!['superadmin', 'devel'].includes(role)) {
                    return {
                        name: 'MapPage'
                    };
                }

                return true;
            }
        },
        {
            path: '/adminglobal',
            name: 'AdminGlobal',
            component: AdminGlobalPage
        },
        {
            path: '/alarmTypes',
            name: 'alarm-types',
            component: AlarmTypesPage
        },
        {
            path: '/corridoringlist',
            name: 'CorridoringList',
            component: CorridoringList,
            meta: { requiresClient: true }
        },
        {
            path: '/missionslist',
            name: 'MissionsList',
            component: MissionsList,
            meta: { requiresClient: true }
        },
        {
            path: '/missionsmembers',
            name: 'MissionsMembers',
            component: MissionsMembers,
            meta: { requiresClient: true }
        },
        {
            path: '/missionshistory',
            name: 'MissionsHistory',
            component: MissionsHistory,
            meta: { requiresClient: true }
        },
        {
            path: '/geocoding',
            name: 'Geocoding',
            component: GeocodingPage,
            meta: { requiresClient: true }
        },
        {
            path: '/faq',
            name: 'FAQPage',
            component: FAQPage
        },
        {
            path: '/contact',
            name: 'ContactPage',
            component: ContactPage
        },
        {
            path: '/serverstatus',
            name: 'ListenersStatus',
            component: ListenersStatus
        },
        {
            path: '/positions/:id',
            name: 'PositionsPage',
            component: PositionsPage
        },
        {
            path: '/drives/:id',
            name: 'DrivesList',
            component: DrivesList
        },
        {
            path: '/drivepositions/:id',
            name: 'DriveInfo',
            component: DriveInfo
        },
        {
            path: '/patchnotes',
            name: 'PatchNotes',
            component: PatchNotes
        },
        {
            path: '/alerts/:id',
            name: 'AlarmsList',
            component: AlarmsList
        },
        {
            path: '/drivemap/:driveid',
            name: 'DriveMapPage',
            component: DriveMapPage
        },
        {
            path: '/dailymap/:baliseId',
            name: 'DailyHistoryMap',
            component: DailyHistoryMap,
            props: route => ({
                baliseId: route.params.baliseId,
                date: route.query.date

            })
        },
        {
            path: '/corridoringmap/:corridoringId',
            name: 'CorridoringMap',
            component: CorridoringMap
        },
        {
            path: '/geofencingmap/:geofencingId?',
            name: 'GeofencingMap',
            component: GeofencingMap,
            meta: { requiresClient: true }
        },
        {
            path: '/missionmap/:id',
            name: 'MissionMap',
            component: MissionMap
        },
        {
            path: '/missionhistorymap/:id',
            name: 'MissionHistoryMap',
            component: MissionHistoryMap
        },
        {
            path: '/mission/:id',
            name: 'MissionInfo',
            component: MissionInfo
        },
        // --- Wizard de création (pas d'id au départ) ---
        // ⚠️ À placer AVANT /mission/:id pour que "new" ne soit pas pris pour un :id
        {
            path: '/mission/new',
            name: 'MissionWizardCreate',
            component: WizardName,
            // le composant peut lire `mode === 'create'` pour POST puis rediriger vers /mission/:id/setup/vehicle
            props: { mode: 'create' },
            meta: { tutorialLink: '/tutorial/mission/3' }
        },
        {
            path: '/mission/:id/setup',
            component: MissionWizardLoader,
            children: [
                {
                    path: 'name',
                    name: 'MissionWizardName',
                    component: WizardName,
                    props: true,
                    meta: { tutorialLink: '/tutorial/mission/3' }
                },
                {
                    path: 'transporteur',
                    name: 'MissionWizardTransporteur',
                    component: WizardTransporteur,
                    props: true,
                    meta: { tutorialLink: '/tutorial/mission/4' }
                },
                {
                    path: 'driver',
                    name: 'MissionWizardDrivers',
                    component: WizardDrivers,
                    props: true,
                    meta: { tutorialLink: '/tutorial/mission/5' }
                },
                {
                    path: 'convoy',
                    name: 'MissionWizardConvoy',
                    component: WizardConvoy,
                    props: true,
                    meta: { tutorialLink: '/tutorial/mission/6' }
                },
                {
                    path: 'plates',
                    name: 'MissionWizardPlates',
                    component: WizardPlates,
                    props: true,
                    meta: { tutorialLink: '/tutorial/mission/8' }
                },
            ]
        },
        {
            path: '/precheckcrud',
            name: 'MissionPrecheckCrud',
            component: MissionPrecheckCrud
        },
        {
            path: '/balisecmd',
            name: 'BaliseCommand',
            component: BaliseCommand
        },
        {
            path: '/contactlist',
            name: 'ContactList',
            component: ContactList
        },
        {
            path: '/billing',
            name: 'BillingPage',
            component: BillingPage
        },
        {
            path: '/billing/revenue-progress',
            name: 'RevenueProgress',
            component: RevenueProgress
        },
        {
            path: '/missionauditlogs',
            name: 'MissionAuditLogs',
            component: MissionAuditLogs
        },
        {
            path: '/test',
            name: 'TestPage',
            component: TestPage
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard,
        },
        {
            path: '/tutorial/mission/:step(\\d+)?',
            name: 'MissionTutorial',
            component: MissionTutorial,
            props: route => ({ step: route.params.step ? Number(route.params.step) : null })
        },
        {
            path: '/select-client',
            name: 'ClientRequired',
            component: () => import('./views/ClientRequired.vue')  // ou import direct si tu préfères
        }
    ]
})

import UserHelper from '@/helpers/user.helper.js'


// Auto redirect to login page if no user detected
router.beforeEach((to) => {
    if (
        !store.state.auth.user &&
        to.name !== 'LoginPage' &&
        !to.meta?.isPublic
    ) {
        return { name: 'LoginPage', query: { from: window.location.pathname } }
    }

    // 2) Client gate pour admin/op
    const role = store.state?.auth?.user?.role
    const isAdminOrOp = ['superadmin', 'devel', 'superoperator'].includes(role)
    if (isAdminOrOp && to.meta?.requiresClient) {
        const cid = UserHelper.getClientId()
        if (!cid || Number(cid) === 0) {
            if (to.name !== 'ClientRequired') {
                return { name: 'ClientRequired', query: { from: to.fullPath } }
            }
        }
    }
})



const app = createApp(App)


// Détection de la plateforme native (Capacitor)
const platform = Capacitor.getPlatform();

if (platform === 'android') {
    document.body.classList.add('android-app');
}
else if (platform === 'ios') {
    document.body.classList.add('ios-app');
}

/**
* Global date management functions using moment
*/
moment.locale('fr')
app.config.globalProperties.$filters = {
    timeAgo(date) {
        if (moment(date).fromNow() == "Invalid date") {
            return "Aucune donnée";
        }
        else {
            return moment(date).fromNow();
        }
    },
    dayDateFormat(value) {
        if (value) {
            return moment(String(value)).format('DD/MM/YYYY');
        }
    },
    secondDateFormat(value) {
        if (value) {
            return moment(String(value)).format('DD/MM/YYYY à HH:mm:ss');
        }
    },
}

app.config.globalProperties.$version = 2.67;
app.config.globalProperties.$largeSreen = window.innerWidth > 900;
// Rôles globaux réactifs (utilisables partout : this.$isAdmin, v-if="$isViewer", etc.)
const role = () => (store.state?.auth?.user?.role ?? null);
Object.defineProperties(app.config.globalProperties, {
    $isAdmin: { get: () => ['superadmin', 'devel'].includes(role()) },
    $isOperator: { get: () => role() === 'superoperator' },
    $isViewer: { get: () => role() === 'clientviewer' },
    $isClientUser: { get: () => role() === 'clientoperator' },
    $isClientAdmin: { get: () => role() === 'clientadmin' },
});

app.component('font-awesome-icon', FontAwesomeIcon);
app.component('v-select', vSelect)
app.use(router);
app.use(store);
app.mount('#app');